<template>
  <v-dialog v-model="dialog" width="800" :retain-focus="false">
    <v-card>
      <v-card-title class="headline">
        <span>{{ service.type ? service.type.name : '' }} </span>
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <p class="mt-2">Aktywna</p>
              <v-switch
                  v-model="service.isActive"
                  class="mt-0 pt-0"
                  :label="service.isActive ? 'Tak' : 'Nie'"
                  :persistent-hint="true"
              ></v-switch>
              <p class="mt-2">Promowana</p>
              <v-switch
                  v-model="service.promoted"
                  class="mt-0 pt-0"
                  :label="service.promoted ? 'Tak' : 'Nie'"
                  :persistent-hint="true"
              ></v-switch>
              <v-img v-bind:src="service.image.url" v-if="service.image"></v-img>
              <v-btn v-if="service.image" v-on:click="removeImage">usuń zdjęcie</v-btn>
              <v-select
                  v-model="service.vatRate"
                  :items="vatRates"
                  label="Stawka VAT"
              ></v-select>
              <v-text-field
                  v-if="service.availableWithTransport"
                  v-model="service.priceWithTransport"
                  class="pt-0"
                  type="number"
                  label="Cena netto"
                  placeholder=" "
              ></v-text-field>
              <p class="mt-2" v-if="service.availableWithTransport">Opis</p>
              <ckeditor
                  v-if="service.availableWithTransport"
                  v-model="service.availableWithTransportDescription"
                  :editor="editor"
                  :config="editorConfig"
                  class="pt-0"
                  hint="Opis"
                  placeholder="Opis"
              ></ckeditor>
              <p class="mt-2" v-if="service.availableWithTransport">Szczegóły usługi po zamówieniu</p>
              <ckeditor
                  v-if="service.availableWithTransport"
                  v-model="service.availableWithTransportSummary"
                  :editor="editor"
                  :config="editorConfig"
                  class="mt-4"
                  label="test"
                  hint="Szczegóły usługi po zamówieniu"
                  placeholder="Szczegóły usługi po zamówieniu"
              ></ckeditor>
              <vue-dropzone id="dropzone" :options="dropzoneOptions" class="mt-4"
                            v-on:vdropzone-success="storeImageId"
                            v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                large
            >Zapisz&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'
import vue2Dropzone from "vue2-dropzone";
import {Auth} from "../services/Auth";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';
import unitMixin from "@/mixins/unitMixin";

export default {
  name: 'ModalEditService',
  components: {
    vueDropzone: vue2Dropzone,
    ckeditor: CKEditor.component,
  },
  props: {
    item: {},
  },
  mixins: [
    transactionTypeMixin,
    transportConditionMixin,
    categoryMixin,
    priceMixin,
    paymentConditionMixin,
    dateMixin,
    validationHelpers,
    unitMixin
  ],
  created() {
    this.loadPartners();
  },
  data() {
    return {
      partners: null,
      unit: "",
      dialog: false,
      form: {
        photosIds: [],
      },
      serviceBuyTypes: [
        {value: 'paidUtilization', text: 'Płatna utylizacja'},
        {value: 'wastePurchase', text: 'Kupno odpadu'},
      ],
      whoTransport: [
        {value: null, text: 'Wybierz'},
        {value: 'client', text: 'Klient'},
        {value: 'seller', text: 'Sprzedawca'},
        {value: 'wm', text: 'Wastemaster'},
      ],
      wmRoles: [
        {value: 'mediation', text: 'Pośrednictwo'},
        {value: 'sell', text: 'Sprzedaż'},
      ],
      feePayer: [
        {value: 'client', text: 'Klient'},
        {value: 'partner', text: 'Partner'},
      ],
      formRules: {
        unit: [(value) => !!value || 'wybierz jednostkę'],
        buyType: [(value) => !!value || 'wybierz typ'],
      },
      valid: false,
      serviceTypes: [],
      service: {
        partner: null,
        type: null,
        wmRole: null,
        wmPrice: null,
        whoPayForWm: null,
        whoTransport: null,
        buyType: null,
        availableWithTransport: true,
        availableWithTransportDescription: '',
        availableWithTransportSummary: '',
        priceWithTransport: '',
        availableWithoutTransport: false,
        availableWithoutTransportDescription: '',
        availableWithoutTransportSummary: '',
        priceWithoutTransport: null,
        photosIds: [],
        removePhoto: false,
        unit: '',
        isSale: true,
        vatRate: null,
        minimumQuantity: null,
        maximumQuantity: null,
        isActive: false,
        promoted: false,
      },
      vatRates: [0, 5, 8, 23],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}/api/price-list/company-branch/${this.item}/service/images`,
        thumbnailWidth: 150,
        maxFilesize: 1024 * 20,
        maxFiles: 1,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
        }
      },
      editor: ClassicEditor,
      editorConfig: {
        id: this.item,
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ],
        }
      },
    }
  },
  methods: {
    open(service) {
      this.service = service;
      this.dialog = true
      this.getServiceTypes();
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const service = {
        partner: this.service.partner ? this.service.partner.id : null,
        availableWithTransport: this.service.availableWithTransport ?? false,
        availableWithTransportDescription: this.service.availableWithTransportDescription ?? '',
        availableWithTransportSummary: this.service.availableWithTransportSummary ?? '',
        priceWithTransport: this.service.priceWithTransport !== '' ? parseFloat(this.service.priceWithTransport) : null,
        availableWithoutTransport: this.service.availableWithoutTransport ?? false,
        availableWithoutTransportDescription: this.service.availableWithoutTransportDescription ?? '',
        availableWithoutTransportSummary: this.service.availableWithoutTransportSummary ?? '',
        priceWithoutTransport: this.service.priceWithoutTransport ? parseFloat(this.service.priceWithoutTransport) : null,
        unit: 'PIECE',
        photosIds: this.form.photosIds,
        removePhoto: this.service.removePhoto,
        isSale: this.service.isSale,
        isActive: this.service.isActive,
        promoted: this.service.promoted,
        vatRate: this.service.vatRate,
        buyType: this.service.buyType,
        wmRole: this.service.wmRole,
        wmPrice: this.service.wmPrice,
        whoPayForWm: this.service.whoPayForWm,
        whoTransport: this.service.whoTransport,
        minimumQuantity: this.service.minimumQuantity !== '' ? this.service.minimumQuantity : null,
        maximumQuantity: this.service.maximumQuantity !== '' ? this.service.maximumQuantity : null,
      }
      api
          .put('/api/price-list/company-branch/' + this.item + '/service/' + this.service.id, service)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Usługa została zaktualizowana.',
            });
            this.dialog = false;
            this.service.type = '';
            this.$parent.load();
          })
          .catch((error) => {
            console.error('Error when editing a service:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    getServiceTypes() {
      api
          .get('/api/price-list/company-branch/' + this.item + '/service/type')
          .then((response) => {
            response.data.forEach(service => {
              service.name = service.name + ' - ' + service.category;
              this.serviceTypes.push(service);
            });
          })
          .catch((error) => {
            console.error('Error when getting a service types:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    storeImageId(event, image) {
      this.form.photosIds.push(image.id);
    },
    removeImage() {
      this.service.image = null;
      this.service.removePhoto = true;
      this.form.photosIds = [];
    },
    async loadPartners() {
      api
          .get('/api/companies?partner=true')
          .then((data) => {
            this.partners = data.data.items;
          })
          .catch((error) => {
            console.error('Error when loading partners: ', error);
          })
    },
  },
}
</script>

<style scoped></style>
